/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomComponent {
    getFixupPrototypeFunction() { return AppSecopsSbomComponent.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomComponent>): AppSecopsSbomComponent {
        let obj = Object.assign(new AppSecopsSbomComponent(), model);
        AppSecopsSbomComponent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomComponent>): AppSecopsSbomComponent {
        if (!model) return null;
        return AppSecopsSbomComponent.newInstance(<AppSecopsSbomComponent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomComponent) {
        if (!obj) return;

        models.AppSecopsSbomComponent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomComponent): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomComponent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.external_references) {
            for (let val of this.external_references) {
                models.AppSecopsExternalReferenceDetail.fixupPrototype(val);
            }
        }
        if (this.licenses) {
            for (let val of this.licenses) {
                models.AppSecopsLicenseDetails.fixupPrototype(val);
            }
        }
        if (this.properties) {
            for (let val of this.properties) {
                models.AppSecopsSbomComponentProperty.fixupPrototype(val);
            }
        }
    }

    /**
     * Author of the component
     */
    author: string;

    /**
     * Unique identifier for the component
     */
    component_id: string;

    /**
     * Common Platform Enumeration (CPE) identifier for the component
     */
    cpe: string;

    /**
     * List of dependent component references
     */
    dependent_component_ids: Array<string>;

    /**
     * Description of the component
     */
    description: string;

    external_references: Array<models.AppSecopsExternalReferenceDetail>;

    /**
     * License for the component
     */
    licenses: Array<models.AppSecopsLicenseDetails>;

    /**
     * Name of the component
     */
    name: string;

    properties: Array<models.AppSecopsSbomComponentProperty>;

    /**
     * Package URL (PURL) that uniquely identifies the component across ecosystems
     */
    purl: string;

    /**
     * Version of the component
     */
    version: string;

    /**
     * Sbom component type
     */
    component_type: models.AppSecopsSbomComponentType;

}
